// Az alap lista, hogy az adot komponenst melyik komponens blokkolja
// Függvény, hogy minden objektumban csak egy klón legyen (lásd: vue komponensekben a data)
module.exports = function() {
    return {
        action: false, // Ha akció miatt van blokkolva
        actionType: false, // Ha akció típusa miatt van blokkolva
        area: false,   // Ha terület miatt van blokkolva
        basic: false,  // Ha a basic nézet miatt van blokkolva
        gate: false,   // Ha kaputerület miatt van blokkolva (van ilyen?)
        player: false, // Ha játékos miatt van blokkolva
        team: false,   // Ha csapat miatt van blokkolva
        time: false,   // Ha az óra 00:00-n áll
    };
};
